import type { ContactSectionConfigType } from '@/components/sections/ContactSection';
import type { ImagesItemsSectionConfigType } from '@/components/sections/ImagesItemsSection';
import type { ItemsContainerSectionProps } from '@/components/sections/ItemsContainerSection';

import { CONTACT_SECTION_CONFIG_RO } from './common';

import { env } from '@/env.mjs';

type PopupContentType = {
    modalTitle: string;
    orderedCardSection: ItemsContainerSectionProps;
    imagesItemsSection: ImagesItemsSectionConfigType;
    contactSection: ContactSectionConfigType;
};

export const POPUP_CONFIG_RO: PopupContentType = {
    modalTitle: 'Cum funcționează?',
    orderedCardSection: {
        headerContentText: {
            textConfig: [
                {
                    type: 'heading3',
                    text: 'Cumpărați acum, plătiți în 30 de zile',
                    className:
                        'text-xl md:text-2xl lg:text-2xl text-center heading-spaces',
                },
            ],
        },
        containerConfig: {
            flexOptions: {
                preset: 'full',
            },
        },
        items: [
            {
                type: 'ordered-card',
                config: {
                    'data-test-id':
                        'start-section-how-it-works-tab-content-ordered-card-1',
                    className: 'w-full !mb-6',
                    number: '1',
                    numberBgColor: 'bg-green-500',
                    content:
                        '<b>Când faci cumpărături online</b>, adaugi produsele în coșul de cumpărături și <b>alegi să plătești prin PayPo.</b>',
                },
            },
            {
                type: 'ordered-card',
                config: {
                    'data-test-id':
                        'start-section-how-it-works-tab-content-ordered-card-2',
                    className: 'w-full !mb-6',
                    number: '2',
                    numberBgColor: 'bg-yellow-600',
                    content:
                        '<b>Completezi datele personale</b> solicitate pentru verificarea informațiilor și transmiterea codului SMS.',
                },
            },
            {
                type: 'ordered-card',
                config: {
                    'data-test-id':
                        'start-section-how-it-works-tab-content-ordered-card-3',
                    className: 'w-full !mb-6',
                    number: '3',
                    numberBgColor: 'bg-brand-fuchsia',
                    content:
                        '<b>PayPo plătește pentru achizițiile tale online din magazin</b>, iar tu vei avea până la <b>30 de zile</b> termen de plată, fără costuri suplimentare.',
                },
            },
        ],
    },
    imagesItemsSection: {
        title: [
            {
                type: 'heading4',
                text: 'Beneficii',
                className: 'text-lg md:text-3xl text-center heading-spaces',
            },
        ],
        columns: 2,
        list: [
            {
                id: '1',
                image: {
                    src: '/images/icons/calendar.svg',
                    alt: 'Iconiță calendar',
                },
                description:
                    'Ai la dispoziție 30 de zile pentru plată – <b>fără costuri suplimentare</b>',
            },
            {
                id: '2',
                image: {
                    src: '/images/icons/boxes.svg',
                    alt: 'Iconiță colete',
                },
                description:
                    '<b>Verifică produsele acasă</b> – produsele pe care nu le dorești, le poți returna către magazin, iar la final vei achita doar produsele păstrate',
            },
            {
                id: '5',
                image: {
                    src: '/images/icons/bag-security.svg',
                    alt: 'Iconiță cumpărături sigure',
                },
                description:
                    'Cumperi în siguranță - <b>plătești doar după ce ai decis ce produse vei păstra</b>',
            },
            {
                id: '6',
                image: {
                    src: '/images/icons/box-security.svg',
                    alt: 'Iconiță plată avantajoasă',
                },
                description:
                    'Plata prin PayPo este <b>mai eficientă și mai avantajosă decât plata ramburs la livrare</b>',
            },
        ],
        additionalText: `Serviciul este disponibil pentru clienții noi PayPo. Informațiile nu constituie o ofertă. Mai multe detalii pot fi găsite în Termenii și condițiile serviciului PayPo - cumpără acum, plătește în 30 de zile pe site-ul <a className="text-green-600" href="${env.NEXT_PUBLIC_APP_URL}/">paypo.ro</a>.`,
    },
    contactSection: {
        isPopup: true,
        ...CONTACT_SECTION_CONFIG_RO,
    },
};
